import SafeVideoPlayer from './Components/SafeVideoPlayer';
import OptionsModal from './Components/SafeVideoPlayer/OptionsModal';
import OptionItem from './Components/SafeVideoPlayer/OptionsModal/OptionItem';

export { OptionsModal, OptionItem };

export default SafeVideoPlayer;

export * from 'react-native-video';
